import type { PlatformLibraryExam, PlatformLibraryFilters, PlatformLibraryInventory, PlatformLibraryList, PlatformLibraryQuery, PlatformLibraryQuestionDetail } from "@pustak-lms/contracts";

export function platformLibraryClient(request: <T>(path: string) => Promise<T>) {
  const base = "/api/manage/platform-library";
  const queryString = (query: PlatformLibraryQuery) => {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
      if (value !== undefined && value !== "" && value !== false) params.set(key, String(value));
    }
    return `?${params}`;
  };
  return {
    listPlatformLibraryExams: () => request<PlatformLibraryExam[]>(`${base}/exams`),
    getPlatformLibraryInventory: (query: PlatformLibraryFilters) => request<PlatformLibraryInventory>(`${base}/inventory${queryString(query)}`),
    listPlatformLibraryQuestions: (query: PlatformLibraryQuery) => request<PlatformLibraryList>(`${base}/questions${queryString(query)}`),
    getPlatformLibraryQuestion: (id: string, examId: string) => request<PlatformLibraryQuestionDetail>(`${base}/questions/${encodeURIComponent(id)}?${new URLSearchParams({ examId })}`),
  };
}
